import { forwardRef, HTMLAttributes, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Tooltip } from 'react-bootstrap';

interface PortalTooltipProps extends HTMLAttributes<HTMLDivElement> {
	children: React.ReactNode;
	id: string;
	placement?: 'top' | 'bottom' | 'left' | 'right';
	className?: string;
}

const PortalTooltip = forwardRef<HTMLDivElement, PortalTooltipProps>((props, ref) => {
	const { children, id, placement, className, ...rest } = props;
	const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(null);

	useEffect(() => {
		// Ensure we have a valid container
		if (!portalContainer) {
			const container = document.body;
			setPortalContainer(container);
		}
	}, [portalContainer]);

	if (!portalContainer) {
		return null;
	}

	return ReactDOM.createPortal(
		<Tooltip ref={ref} id={id} placement={placement} className={className} {...rest}>
			{children}
		</Tooltip>,
		portalContainer
	);
});

PortalTooltip.displayName = 'PortalTooltip';

export default PortalTooltip;
